import { Meter, MeterRequest, MetersResponse, MeterUpdateRequest } from '../types/asset';
import { client } from './index';

async function getMeters(search?: string, page?: number, nameOrder?: 'asc' | 'desc') {
  const params = new URLSearchParams();
  if (search) params.append('search', search);
  if (page) params.append('page', page.toString());
  if (nameOrder) params.append('name_order', nameOrder);

  const queryString = params.toString() ? `?${params.toString()}` : '';
  const url = `/meters${queryString}`;

  const response = await client.get<MetersResponse>(url);
  const { data } = response;
  return data;
}

async function getMeter(id: number) {
  const response = await client.get<Meter>(`/meters/${id}`);
  const { data } = response;
  return data;
}

async function createMeter(meterData: MeterRequest) {
  const response = await client.post<{ meter: Meter }>('/meters', { meter: meterData });
  const { data } = response;
  return data;
}

async function updateMeter(id: number, meterData: MeterUpdateRequest) {
  const response = await client.put<{ meter: Meter }>(`/meters/${id}`, { meter: meterData });
  const { data } = response;
  return data;
}

async function duplicateMeter(id: number) {
  const response = await client.post<{ meter: Meter }>(`/meters/${id}/duplicate`);
  const { data } = response;
  return data;
}

export const metersApi = {
  getMeters,
  getMeter,
  createMeter,
  updateMeter,
  duplicateMeter,
};
